import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { EConsentUserType, eConsentUserTypeToString } from "../../contexts/EConsentContext";

const useEConsentFormCancel = (user: EConsentUserType | undefined | null, eConsentGuid: string | undefined | null, onCancel: (() => void) | undefined) => {
    const params = useParams();
    const navigate = useNavigate();
    
    const onFormCancel = useCallback(() => {
        if (onCancel) {
            onCancel();
        }
        else {
            navigate(`/trial-consent/${eConsentUserTypeToString(user)}/econsent/${eConsentGuid}`);
        }
    }, [navigate, params, onCancel, eConsentGuid, user]);

    return onFormCancel;
};

export default useEConsentFormCancel;